import React from "react";

const TreeNode: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    width={200}
    height={200}
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M256 42.666667a42.666667 42.666667 0 0 1 41.984 34.986666L298.666667 85.333333v783.530667h503.893333a42.666667 42.666667 0 0 1 41.984 34.986667l0.682667 7.68a42.666667 42.666667 0 0 1-34.986667 41.984l-7.68 0.682666H256a42.666667 42.666667 0 0 1-41.984-34.986666l-0.682667-7.68V85.333333A42.666667 42.666667 0 0 1 256 42.666667z"
      fill="#A9A9AA"
    />
    <path
      d="M784.128 426.666667a42.666667 42.666667 0 0 1 7.68 84.650666L784.128 512H256a42.666667 42.666667 0 0 1-7.68-84.650667L256 426.666667h528.128z"
      fill="#A9A9AA"
    />
  </svg>
);

export default TreeNode;
